module.exports = __webpack_public_path__ + "img/user-default.d440ce3b.svg";